export default __webpack_public_path__ + "static/media/patterns-no-1.844b8aef.ogg";